// extracted by mini-css-extract-plugin
export default {"searchStyle":"SearchFilter_searchStyle__7lm6C","customInputStyle":"SearchFilter_customInputStyle__xgWuV","input-group-text":"SearchFilter_input-group-text__ckvJv"};